const custStatistics = {
    path: 'custStatistics',
    name: 'custStatistics',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'customerStatistics',
        icon: 'HSIconfont hs-icon-stat',
        showRealm: ['SYSTEM', 'ADMIN']
    },
    children: [
        // // TODO 更改权限
        // {
        //     path: 'custStatisticAssets',
        //     name: 'custStatisticAssets',
        //     component: () => import('@/views/custStatisticAssets'),
        //     meta: { code: 'esl:failedList' }
        // },
        {
            path: 'custStatisticsEsl',
            name: 'custStatisticsEsl',
            component: () => import('@/views/custStatisticsEsl'),
            meta: { code: 'customerStatistics:abnormalEsl' }
        },
        {
            path: 'custStatisticsAp',
            name: 'custStatisticsAp',
            component: () => import('@/views/custStatisticsAp'),
            meta: { code: 'customerStatistics:statisticsAp' }
        },
        {
            path: 'custStatisticsDynamicEsl',
            name: 'custStatisticsDynamicEsl',
            component: () => import('@/views/custStatisticsDynamicEsl'),
            meta: { code: 'customerStatistics:statisticsDynamicEsl' }
        },
        {
            path: 'custStatisticsAbStores',
            name: 'custStatisticsAbStores',
            component: () => import('@/views/custStatisticsAbStores'),
            meta: { code: 'customerStatistics:customerAbnormalStore' }
        },
        {
            path: 'custStatisticsUsageEsl',
            name: 'custStatisticsUsageEsl',
            component: () => import('@/views/custStatisticsUsageEsl'),
            meta: { code: 'customerStatistics:customerStoreEslUsage' }
        },
        {
            path: 'custStatisticsAbBattery',
            name: 'custStatisticsAbBattery',
            component: () => import('@/views/custStaAbBattery'),
            meta: { code: 'customerStatistics:customerStoreAbnormalBattery' }
        },
        {
            path: 'custStatisticsStore',
            name: 'custStatisticsStore',
            component: () => import('@/views/custStatisticsStore'),
            meta: { code: 'customerStatistics:storeStatistics' }
        },
        {
            path: 'custStatisticMultiEsl',
            name: 'custStatisticMultiEsl',
            component: () => import('@/views/custStatisticMultiEsl'),
            meta: { code: 'customerStatistics:multiEslGoodsStatistics' }
        },
    ]
};
export default custStatistics;